import React from 'react'
import clsx from 'clsx'

/**
 * Responsive horizontal padding classes
 * - Mobile (default): 16px (px-v3-sm)
 * - Tablet (sm and above, up to 1440px): 32px (px-v3-lg)
 * - Desktop (1440px and above): 0 (1440px:px-0)
 */
export const PAGE_CONTAINER_PADDING = 'px-v3-sm sm:px-v3-lg 1440px:px-0'

/**
 * PageContainer - A wrapper component that handles responsive horizontal padding
 * 
 * Padding behavior:
 * - Mobile (default): 16px (px-v3-sm)
 * - Tablet (sm and above, up to 1440px): 32px (px-v3-lg)
 * - Desktop (1440px and above): 0 (1440px:px-0)
 * 
 * @param {React.ReactNode} children - Content to wrap
 * @param {string} className - Additional CSS classes
 * @param {boolean} maxWidth - Whether to apply max-width constraint (default: true)
 */
const PageContainer = ({
  children,
  className = '',
  maxWidth = true,
  ...props
}) => {
  return (
    <div
      className={clsx(
        PAGE_CONTAINER_PADDING,
        'h-full',
        'flex flex-col',
        'overflow-hidden',
        maxWidth && 'max-w-[1200px] mx-auto w-full',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export default PageContainer

